import { DuetError } from "@framework/relay/errors";
import Middleware from "@framework/relay/shared/Middleware";

function authMiddleware(token?: string): Middleware {
  return (next) => (ctx) => {
    if (!token && typeof window === "undefined") {
      // If we don't have a token, and we are rendering this on the server
      // then throw when attempting to create a network request.
      throw new DuetError(
        `Unexpected GraphQL network request for '${ctx.operation.operationName}'`,
        {
          extra: {
            operationName: ctx.operation.operationName,
            variables: ctx.operation.variables,
          },
        },
      );
    }
    if (token) {
      ctx.fetchOpts.headers.Authorization = `Bearer ${token}`;
    }

    return next(ctx);
  };
}

export default authMiddleware;
